import React from 'react';

export const View = (): JSX.Element => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: '0px 0px 0px 6.5px',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8333 2.5L4.16667 2.5C3.24167 2.5 2.5 3.25 2.5 4.16667L2.5 15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5L15.8333 17.5C16.75 17.5 17.5 16.75 17.5 15.8333L17.5 4.16667C17.5 3.25 16.7583 2.5 15.8333 2.5ZM15.8333 15.8333L4.16667 15.8333L4.16667 5.83333L15.8333 5.83333L15.8333 15.8333ZM10 12.0833C10.6917 12.0833 11.25 11.525 11.25 10.8333C11.25 10.1417 10.6917 9.58333 10 9.58333C9.30833 9.58333 8.75 10.1417 8.75 10.8333C8.75 11.525 9.30833 12.0833 10 12.0833ZM10 7.5C7.725 7.5 5.78333 8.88333 5 10.8333C5.78333 12.7833 7.725 14.1667 10 14.1667C12.275 14.1667 14.2167 12.7833 15 10.8333C14.2167 8.88333 12.275 7.5 10 7.5ZM7.91667 10.8333C7.91667 11.9833 8.85 12.9167 10 12.9167C11.15 12.9167 12.0833 11.9833 12.0833 10.8333C12.0833 9.68333 11.15 8.75 10 8.75C8.85 8.75 7.91667 9.68333 7.91667 10.8333Z"
        fill="#006298"
      />
      <mask
        id="mask0_39_7451"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="16"
        height="16"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8333 2.5L4.16667 2.5C3.24167 2.5 2.5 3.25 2.5 4.16667L2.5 15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5L15.8333 17.5C16.75 17.5 17.5 16.75 17.5 15.8333L17.5 4.16667C17.5 3.25 16.7583 2.5 15.8333 2.5ZM15.8333 15.8333L4.16667 15.8333L4.16667 5.83333L15.8333 5.83333L15.8333 15.8333ZM10 12.0833C10.6917 12.0833 11.25 11.525 11.25 10.8333C11.25 10.1417 10.6917 9.58333 10 9.58333C9.30833 9.58333 8.75 10.1417 8.75 10.8333C8.75 11.525 9.30833 12.0833 10 12.0833ZM10 7.5C7.725 7.5 5.78333 8.88333 5 10.8333C5.78333 12.7833 7.725 14.1667 10 14.1667C12.275 14.1667 14.2167 12.7833 15 10.8333C14.2167 8.88333 12.275 7.5 10 7.5ZM7.91667 10.8333C7.91667 11.9833 8.85 12.9167 10 12.9167C11.15 12.9167 12.0833 11.9833 12.0833 10.8333C12.0833 9.68333 11.15 8.75 10 8.75C8.85 8.75 7.91667 9.68333 7.91667 10.8333Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_39_7451)"></g>
    </svg>
  );
};

export const FullScreen = (): JSX.Element => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        margin: '0px 0px 0px 8.2px',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83317 7.49996C5.83317 7.95829 5.45817 8.33329 4.99984 8.33329C4.5415 8.33329 4.1665 7.95829 4.1665 7.49996L4.1665 4.99996C4.1665 4.54163 4.5415 4.16663 4.99984 4.16663L7.49984 4.16663C7.95817 4.16663 8.33317 4.54163 8.33317 4.99996C8.33317 5.45829 7.95817 5.83329 7.49984 5.83329L5.83317 5.83329L5.83317 7.49996ZM4.1665 12.5C4.1665 12.0416 4.5415 11.6666 4.99984 11.6666C5.45817 11.6666 5.83317 12.0416 5.83317 12.5L5.83317 14.1666L7.49984 14.1666C7.95817 14.1666 8.33317 14.5416 8.33317 15C8.33317 15.4583 7.95817 15.8333 7.49984 15.8333L4.99984 15.8333C4.5415 15.8333 4.1665 15.4583 4.1665 15L4.1665 12.5ZM14.1665 14.1666L12.4998 14.1666C12.0415 14.1666 11.6665 14.5416 11.6665 15C11.6665 15.4583 12.0415 15.8333 12.4998 15.8333L14.9998 15.8333C15.4582 15.8333 15.8332 15.4583 15.8332 15L15.8332 12.5C15.8332 12.0416 15.4582 11.6666 14.9998 11.6666C14.5415 11.6666 14.1665 12.0416 14.1665 12.5L14.1665 14.1666ZM12.4998 5.83329C12.0415 5.83329 11.6665 5.45829 11.6665 4.99996C11.6665 4.54163 12.0415 4.16663 12.4998 4.16663L14.9998 4.16663C15.4582 4.16663 15.8332 4.54163 15.8332 4.99996L15.8332 7.49996C15.8332 7.95829 15.4582 8.33329 14.9998 8.33329C14.5415 8.33329 14.1665 7.95829 14.1665 7.49996L14.1665 5.83329L12.4998 5.83329Z"
        fill="#006298"
      />
      <mask
        id="mask0_39_7474"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="12"
        height="12"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.83317 7.49996C5.83317 7.95829 5.45817 8.33329 4.99984 8.33329C4.5415 8.33329 4.1665 7.95829 4.1665 7.49996L4.1665 4.99996C4.1665 4.54163 4.5415 4.16663 4.99984 4.16663L7.49984 4.16663C7.95817 4.16663 8.33317 4.54163 8.33317 4.99996C8.33317 5.45829 7.95817 5.83329 7.49984 5.83329L5.83317 5.83329L5.83317 7.49996ZM4.1665 12.5C4.1665 12.0416 4.5415 11.6666 4.99984 11.6666C5.45817 11.6666 5.83317 12.0416 5.83317 12.5L5.83317 14.1666L7.49984 14.1666C7.95817 14.1666 8.33317 14.5416 8.33317 15C8.33317 15.4583 7.95817 15.8333 7.49984 15.8333L4.99984 15.8333C4.5415 15.8333 4.1665 15.4583 4.1665 15L4.1665 12.5ZM14.1665 14.1666L12.4998 14.1666C12.0415 14.1666 11.6665 14.5416 11.6665 15C11.6665 15.4583 12.0415 15.8333 12.4998 15.8333L14.9998 15.8333C15.4582 15.8333 15.8332 15.4583 15.8332 15L15.8332 12.5C15.8332 12.0416 15.4582 11.6666 14.9998 11.6666C14.5415 11.6666 14.1665 12.0416 14.1665 12.5L14.1665 14.1666ZM12.4998 5.83329C12.0415 5.83329 11.6665 5.45829 11.6665 4.99996C11.6665 4.54163 12.0415 4.16663 12.4998 4.16663L14.9998 4.16663C15.4582 4.16663 15.8332 4.54163 15.8332 4.99996L15.8332 7.49996C15.8332 7.95829 15.4582 8.33329 14.9998 8.33329C14.5415 8.33329 14.1665 7.95829 14.1665 7.49996L14.1665 5.83329L12.4998 5.83329Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_39_7474)"></g>
    </svg>
  );
};

export const DeleteIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m12.325 2.742.591.591H15c.458 0 .833.375.833.834A.836.836 0 0 1 15 5H5a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834h2.083l.592-.591a.84.84 0 0 1 .583-.242h3.484a.84.84 0 0 1 .583.242zM5 15.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V7.5c0-.917-.75-1.667-1.667-1.667H6.666C5.75 5.833 5 6.583 5 7.5v8.333zM7.5 7.5h5c.458 0 .833.375.833.833V15a.836.836 0 0 1-.833.833h-5A.836.836 0 0 1 6.667 15V8.333c0-.458.375-.833.833-.833z"
        fill="#C61D23"
      />
      <mask id="a" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="4" y="2" width="12" height="16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m12.325 2.742.591.591H15c.458 0 .833.375.833.834A.836.836 0 0 1 15 5H5a.836.836 0 0 1-.833-.833c0-.459.375-.834.833-.834h2.083l.592-.591a.84.84 0 0 1 .583-.242h3.484a.84.84 0 0 1 .583.242zM5 15.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V7.5c0-.917-.75-1.667-1.667-1.667H6.666C5.75 5.833 5 6.583 5 7.5v8.333zM7.5 7.5h5c.458 0 .833.375.833.833V15a.836.836 0 0 1-.833.833h-5A.836.836 0 0 1 6.667 15V8.333c0-.458.375-.833.833-.833z"
          fill="#fff"
        />
      </mask>
    </svg>
  );
};
